<template>
  <div class="content-page">
    <div class="bd">
      <div class="tab-header">
        <div class="header-left">
          <el-button type="primary" size="small" @click="addBooking">添加预约</el-button>
        </div>
        <div class="header-right">
          <div>
            <span>到店时间：</span>
            <el-date-picker
              v-model="arrivalTime"
              size="small"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="arrivalTimePickerOptions"
            >
            </el-date-picker>
          </div>
          <div>
            <span>选择手艺人：</span>
            <el-select
              popper-class="screen-select"
              v-model="workUserId"
              size="small"
              placeholder="请选择手艺人"
            >
              <el-option
                v-for="item in screenArtisansList"
                :key="item.workUserId"
                :label="item.nickName"
                :value="item.workUserId"
              >
              </el-option>
            </el-select>
          </div>
          <div>
            <span>到店人姓名：</span>
            <el-input
              placeholder="请输入到店人姓名"
              v-model.trim="peopleName"
              class="input-search"
              size="small"
              @keyup.enter.native="getPageData"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="getPageData"
              ></el-button>
            </el-input>
          </div>
          <div>
            <span>到店人手机号：</span>
            <el-input
              placeholder="请输入到店人手机号"
              v-model.trim="phoneNum"
              class="input-search"
              size="small"
              @keyup.enter.native="getPageData"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="getPageData"
              ></el-button>
            </el-input>
          </div>
        </div>
      </div>
      <div class="tab-content">
        <el-tabs v-model="activeName" type="card">
          <el-tab-pane
            v-for="item in orderClassifyList"
            :key="String(item.orderStatus)"
            :label="String(item.orderStatusName)"
            :name="String(item.orderStatus)"
          >
            <span slot="label">
              <span>{{ item.orderStatusName }}</span>
            </span>
          </el-tab-pane>
        </el-tabs>
        <div class="list" v-loading="isLoading">
          <el-table :data="orderList" style="width: 100%">
            <el-table-column label="预约顾客" align="left">
              <template slot-scope="scope">
                <div class="name">{{ scope.row.peopleName }}</div>
                <div class="phonenum">{{ scope.row.phoneNum }}</div>
              </template>
            </el-table-column>
            <el-table-column label="预约内容" align="center">
              <template slot-scope="scope">
                <div>
                  {{ scope.row.goodsName ? scope.row.goodsName : "未选择服务" }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="手艺人" align="center">
              <template slot-scope="scope">
                <div class="name">
                  {{ scope.row.nickName ? scope.row.nickName : "-" }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="预约到店时间" align="left">
              <template slot-scope="scope">
                <div class="time">
                  {{ new Date(scope.row.startTimeStr).pattern("HH:mm") }}
                </div>
                <div class="date gray">
                  {{ dateComputed(scope.row.startTimeStr) }}
                </div>
                <div
                  class="overtime"
                  style="color: rgb(212, 0, 0)"
                  v-if="overtimeComputed(scope.row.startTimeStr)"
                >
                  {{ overtimeComputed(scope.row.startTimeStr) }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="实际到店时间" align="center" v-if="activeName == 20">
              <template slot-scope="scope">
                {{ scope.row.arrivalTimeStr ? scope.row.arrivalTimeStr : "" }}
              </template>
            </el-table-column>
            <el-table-column
              label="开单时间"
              align="center"
              v-if="activeName != 10 && activeName != 30 && activeName != -10"
            >
              <template slot-scope="scope">
                {{ scope.row.openOrderTimeStr ? scope.row.openOrderTimeStr : "" }}
              </template>
            </el-table-column>
            <el-table-column label="顾客备注" align="center" v-if="activeName != 'all'">
              <template slot-scope="scope">
                {{ scope.row.buyerReMark ? scope.row.buyerReMark : "-" }}
              </template>
            </el-table-column>
            <el-table-column label="商家备注" align="center" v-if="activeName != 'all'">
              <template slot-scope="scope">
                {{ scope.row.shoperRemark ? scope.row.shoperRemark : "-" }}
              </template>
            </el-table-column>
            <el-table-column label="状态" align="center" v-if="activeName == 'all'">
              <template slot-scope="scope">
                {{
                  orderClassifyList[
                    orderClassifyList.findIndex((val) => {
                      return (
                        String(val.orderStatus).indexOf(String(scope.row.status)) != -1
                      );
                    })
                  ].orderStatusName
                }}
              </template>
            </el-table-column>
            <el-table-column label="下单时间" align="center">
              <template slot-scope="scope">
                {{ scope.row.createTime ? scope.row.createTime : "-" }}
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="300">
              <template slot-scope="scope">
                <div v-if="scope.row.orderType == 0 && scope.row.status == 5">待付款</div>
                <div v-else-if="scope.row.status == -30">
                  <el-button type="success" size="small" @click="confirmAgree(scope.row)"
                    >同意申请</el-button
                  >
                  <el-button type="danger" size="small" @click="confirmReject(scope.row)"
                    >拒绝申请</el-button
                  >
                </div>
                <div v-else>
                  <el-button
                    type="text"
                    size="small"
                    @click="openOrder(scope.row)"
                    v-if="!scope.row.haveBill && isCanEdit(scope.row)"
                    >开单</el-button
                  >
                  <el-button
                    type="text"
                    size="small"
                    @click="confirmArrival(scope.row)"
                    v-if="!scope.row.arrivalTimeStr && isCanEdit(scope.row)"
                    >确认到店</el-button
                  >
                  <el-button
                    type="text"
                    size="small"
                    @click="appointmentOrderInfo(scope.row.appointmentOrderId, 'detail')"
                    >详情</el-button
                  >
                  <el-button
                    type="text"
                    size="small"
                    @click="appointmentOrderInfo(scope.row.appointmentOrderId, 'edit')"
                    v-if="isCanEdit(scope.row) && scope.row.orderType != 0"
                    >更改</el-button
                  >
                  <el-button
                    type="text"
                    size="small"
                    @click="cancelOrder(scope.row)"
                    v-if="isCanEdit(scope.row)"
                    >取消</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="pageSize"
            :current-page="pageNo"
            background
            layout="prev, pager, next, jumper"
            :total="pageCount"
          ></el-pagination>
        </div>
      </div>
    </div>
    <dialogAddBooking ref="dialogaddbooking" @getPageData="getPageData">
    </dialogAddBooking>
  </div>
</template>

<script>
import {
  appointmentOrderList,
  appointmentOrderListCount,
  findArtisans,
  updateAppointmentOrderStatus,
  appointmentOrderInfo,
} from "@/api/index.js";
import dialogAddBooking from "@/components/dialogAddBooking";
import md5 from "js-md5";
export default {
  data() {
    return {
      orderClassifyList: [
        {
          orderStatusName: "全部",
          orderNum: 0,
          orderStatus: "all",
        },
        {
          orderStatusName: "待到店",
          orderNum: 0,
          orderStatus: 10,
        },
        {
          orderStatusName: "已到店",
          orderNum: 0,
          orderStatus: 20,
        },
        {
          orderStatusName: "已开单",
          orderNum: 0,
          orderStatus: "haveBill",
        },
        {
          orderStatusName: "待支付",
          orderNum: 0,
          orderStatus: 5,
        },
        {
          orderStatusName: "已完成",
          orderNum: 0,
          orderStatus: 30,
        },
        {
          orderStatusName: "申请取消",
          orderNum: 0,
          orderStatus: "-30",
        },
        {
          orderStatusName: "已取消",
          orderNum: 0,
          orderStatus: "-10,-20,-50,-40",
        },
      ],
      activeName: "all",
      appointmentDate: "",
      screenArtisansList: [],
      workUserId: "",
      arrivalTime: "",
      arrivalTimePickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "明天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() + 3600 * 1000 * 24 * 1);
              end.setTime(end.getTime() + 3600 * 1000 * 24 * 1);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              console.log(start.getDay());
              start.setTime(start.getTime() + 3600 * 1000 * 24 * (1 - start.getDay()));
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 6);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      startDate: "",
      endDate: "",
      phoneNum: "",
      peopleName: "",
      pageSize: 5,
      pageCount: 0,
      pageNo: 1,

      orderList: [],
      isLoading: false,
    };
  },
  components: {
    dialogAddBooking,
  },
  watch: {
    activeName() {
      this.pageNo = 1;
      this.getPageData();
    },
    menuSel() {
      this.searchGoods();
    },
    workUserId() {
      this.getPageData();
    },
    arrivalTime(val) {
      console.log("arrivalTime", val);
      if (val) {
        this.startDate = new Date(val[0]).pattern("yyyy-MM-dd");
        this.endDate = new Date(val[1]).pattern("yyyy-MM-dd");
      } else {
        this.startDate = "";
        this.endDate = "";
      }
      this.getPageData();
    },
  },
  mounted() {
    if (this.$route.query.type == "add") {
      this.addBooking();
    }
    this.getPageData();
    this.findArtisans("init");
  },
  methods: {
    addBooking() {
      this.$refs.dialogaddbooking.showAddBooking();
    },
    appointmentOrderInfo(appointmentOrderId, type) {
      appointmentOrderInfo({
        appointmentOrderId: appointmentOrderId,
      }).then((res) => {
        if (res.code == 1) {
          let item = res.data;
          console.log("1234", item);
          let addBookingForm = {
            appointmentOrderId: item.appointmentOrderId,
            phoneNum: item.phoneNum,
            peopleName: item.peopleName,
            payMoney: item.payMoney,
            bookingList: [
              {
                serviceInfo: {
                  label: item.goodsName,
                  serviceTime: "",
                  specDesc: item.specDesc,
                },
                goodsId: item.goodsId,
                productId: item.productId,
                workUserId: item.workUserId,
              },
            ],
            appointmentDate: item.appointmentDate,
            hourStep: parseInt((item.endTime - item.startTime) / 1000 / 60 / 60),
            minuteStep: parseInt(((item.endTime - item.startTime) / 1000 / 60) % 60),
            // startTime: new Date(item.startTimeStr).pattern("HH:mm"),
            // endTime: new Date(item.endTimeStr).pattern("HH:mm"),
            startTime: item.startTimePart,
            endTime: item.endTimePart,
            shoperRemark: item.shoperRemark,
            buyerReMark: item.buyerReMark,
            shopMemberId: item.shopMemberId || "",
            cashCouponId: item.cashCouponId || "",
            orderType: item.orderType,
          };
          console.log("123", addBookingForm);
          this.$refs.dialogaddbooking.showAddBooking(type, addBookingForm);
        }
      });
    },
    openOrder(item) {
      this.$router.push(`/home/my/order?appointmentOrderId=${item.appointmentOrderId}`);
    },
    confirmArrival(item) {
      this.updateAppointmentOrderStatus(20, item);
    },
    confirmAgree(item) {
      this.$prompt("请输入密码", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputType: "password",
      })
        .then(({ value }) => {
          updateAppointmentOrderStatus({
            status: -50,
            appointmentOrderId: item.appointmentOrderId,
            managerPassWord: String(md5(value)).toUpperCase(),
          }).then((res) => {
            if (res.code == 1) {
              this.$notify({
                title: "提示",
                message: "操作成功",
                type: "success",
                duration: 2000,
              });
              this.pageNo = 1;
              this.getPageData();
            } else {
              this.$notify({
                title: "提示",
                message: res.msg,
                type: "error",
                duration: 2000,
              });
            }
          });
        })
        .catch(() => {});
    },
    confirmReject(item) {
      this.$prompt("请输入拒绝原因", "拒绝申请", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputType: "textarea",
        inputPlaceholder: "请输入拒绝原因",
        inputValidator: (value) => {
          if (!value || !value.trim()) {
            return "请输入拒绝原因";
          }
          return true;
        },
      })
        .then(({ value }) => {
          this.updateAppointmentOrderStatus(-40, item, {
            failRemark: value.trim(),
          });
        })
        .catch(() => {});
    },
    cancelOrder(item) {
      if (item.orderStatus == 25) {
        this.$prompt("请输入密码", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputType: "password",
        }).then(({ value }) => {
          updateAppointmentOrderStatus({
            status: -10,
            appointmentOrderId: item.appointmentOrderId,
            managerPassWord: String(md5(value)).toUpperCase(),
          }).then((res) => {
            if (res.code == 1) {
              this.$notify({
                title: "提示",
                message: "操作成功",
                type: "success",
                duration: 2000,
              });
              this.pageNo = 1;
              this.getPageData();
            } else {
              this.$notify({
                title: "提示",
                message: res.msg,
                type: "error",
                duration: 2000,
              });
            }
          });
        });
        return;
      }
      this.updateAppointmentOrderStatus(-10, item);
    },
    updateAppointmentOrderStatus(status, item, extraParams = {}) {
      updateAppointmentOrderStatus({
        status: status,
        appointmentOrderId: item.appointmentOrderId,
        ...extraParams,
      }).then((res) => {
        if (res.code == 1) {
          this.$notify({
            title: "提示",
            message: "操作成功",
            type: "success",
            duration: 2000,
          });
          this.pageNo = 1;
          this.getPageData();
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 2000,
          });
        }
      });
    },
    dateComputed(date) {
      let toady = new Date();
      let currentDate = new Date(date);
      if (
        toady.getFullYear() == currentDate.getFullYear() &&
        toady.getMonth() == currentDate.getMonth()
      ) {
        if (currentDate.getDate() - toady.getDate() == 0) {
          return "今天";
        }
        if (currentDate.getDate() - toady.getDate() == 1) {
          return "明天";
        }
      }
      return `${currentDate.getMonth() + 1}-${currentDate.getDate()}`;
    },
    overtimeComputed(date) {
      let toady = new Date();
      let currentDate = new Date(date);
      if (currentDate - toady > 0) return false;
      let overtime = Math.abs(currentDate - toady) / 1000 / 60;
      return `超时${parseInt(overtime / 60 / 24)}天${parseInt(
        (overtime / 60) % 24
      )}小时${parseInt(overtime % 60)}分钟`;
    },
    isCanEdit(item) {
      return item.status == 5 || item.status == 10 || item.status == 20;
    },
    getPageData() {
      this.pageNo = 1;
      this.appointmentOrderList();
      this.appointmentOrderListCount();
    },
    appointmentOrderList() {
      this.isLoading = true;
      let activeName = this.activeName;
      appointmentOrderList({
        pageNo: this.pageNo,
        row: this.pageSize,
        statuss: activeName == "all" || activeName == "haveBill" ? "" : activeName,
        appointmentDate: this.appointmentDate,
        workUserId: this.workUserId,
        startDate: this.startDate,
        endDate: this.endDate,
        phoneNum: this.phoneNum,
        peopleName: this.peopleName,
        haveBill: activeName == "haveBill" ? 1 : 0,
      }).then((res) => {
        if (res.code == 1) {
          this.orderList = res.data;
        }
        if (res.code == -1) {
          this.orderList = [];
        }
        this.isLoading = false;
      });
    },
    appointmentOrderListCount() {
      let activeName = this.activeName;
      appointmentOrderListCount({
        statuss: activeName == "all" || activeName == "haveBill" ? "" : activeName,
        appointmentDate: this.appointmentDate,
        workUserId: this.workUserId,
        startDate: this.startDate,
        endDate: this.endDate,
        phoneNum: this.phoneNum,
        peopleName: this.peopleName,
        haveBill: activeName == "haveBill" ? 1 : 0,
      }).then((res) => {
        if (res.code == 1) {
          this.pageCount = res.data;
        }
        if (res.code == -1) {
          this.pageCount = 0;
        }
      });
    },
    handleSizeChange() {},
    handleCurrentChange(val) {
      this.pageNo = val;
      this.appointmentOrderList();
    },
    findArtisans(type) {
      findArtisans({
        goodsId: type == "init" ? "" : this.addBookingForm.bookingList[0].goodsId,
        productId:
          type == "init" ? "" : this.addBookingForm.bookingList[0].productId || "",
        row: 99999,
      }).then((res) => {
        if (res.code == 1) {
          this.artisansList = res.data;
          if (type == "init") {
            this.screenArtisansList = res.data;
          }
        }
        if (res.code == -1) {
          this.artisansList = [];
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  .header-right {
    & > div {
      margin-left: 20px;
    }
  }
  .tab-content {
    display: block;
    .el-tabs {
      margin: 10px 0 0 10px;
    }
  }
  .upload-xls {
    margin: 0 10px;
  }
  .list {
    width: 100%;
    padding: 0 20px;
    .template-name {
      color: #66b1ff;
      cursor: pointer;
    }
    .status {
      display: inline-block;
      width: 70px;
      margin-right: 5px;
      &.ing {
        color: #ffaa00;
      }
      &.suc {
        color: #7abd54;
      }
      &.fail {
        color: #ff4c4c;
      }
    }
  }
  .tips {
    border: 1px solid #ff9191;
    background-color: #ffe6e6;
    display: block;
    position: relative;
    color: #666;
    font-size: 12px;
    line-height: 30px;
    padding: 8px;
    border-radius: 3px;
    .em {
      color: #3388ff;
    }
  }
}
.popover {
  .title {
    line-height: 30px;
  }
  .content {
    color: #66b1ff;
  }
}
</style>

<style lang="less">
.upload-xls-btn {
  display: inline-block;
  margin: 0 10px;
}
.screen-select {
  width: 200px;
}
</style>
